module.exports = __webpack_public_path__ + "static/media/intro.db6bfb43.mp3";